import { TenantSubscription } from '../../entities/tenant';
import { BaseSecurityModule } from '../base.security.module';
import { SecurityModuleDomain, SecurityModuleName, SecurityRight } from '../security.module';


export enum PortalContractorSecurityRight {
    CanAccessJobs = 61000,
    ManageUsers = 61001,
    ManageCompliance = 61002,
    CanKnowledgeBase = 61004,
    AccessIncomingClaims = 61005,
    AccessOutgoingClaims = 61006,
    ManageIncomingClaims = 61007,
    ManageOutgoingClaims = 61008,
    ModifyFormAfterSubmission = 61009,
}

export class PortalContractorSecurityModule extends BaseSecurityModule<PortalContractorSecurityRight> {

    constructor() {

        super(
            SecurityModuleName.PortalContractors,
            [
                { _id: PortalContractorSecurityRight.CanAccessJobs, name: 'Access Work - Jobs', basic: true },
                { _id: PortalContractorSecurityRight.CanKnowledgeBase, name: 'Access Knowledge Base', basic: true },
                { _id: PortalContractorSecurityRight.ManageUsers, name: 'Manage Users', basic: false },
                { _id: PortalContractorSecurityRight.ManageCompliance, name: 'Manage Compliance', basic: false },
                { _id: PortalContractorSecurityRight.AccessIncomingClaims, name: 'Access Incoming Claims', basic: true },
                { _id: PortalContractorSecurityRight.AccessOutgoingClaims, name: 'Access Outgoing Claims', basic: true },
                { _id: PortalContractorSecurityRight.ManageIncomingClaims, name: 'Manage Incoming Claims', basic: false },
                { _id: PortalContractorSecurityRight.ManageOutgoingClaims, name: 'Manage Outgoing Claims', basic: false },
                { _id: PortalContractorSecurityRight.ModifyFormAfterSubmission, name: 'Modify Form After Submission', basic: false },

            ] as SecurityRight<PortalContractorSecurityRight>[],
            SecurityModuleDomain.Portals
        );

        this.plan = TenantSubscription.Enterprise;
    }

}
